import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {getUserList} from '@/api/common'
import {delNullProperty} from "@/utils";

@Component({})
export default class MoreUsersFilter extends Vue {
    @Prop() usersId: string | object[];
    @Prop() usersName: string | object[];
    @Prop() multiple: boolean; // 多选（B端客户，）
    @Prop() multipleLimit: number; // （审批节点配置）
    @Prop() style1: object; // （数据共享）
    @Prop() isDisibale: boolean; // 是否禁用 市场线索新建
    @Prop() isCheckbox: boolean; // 是否有复选框 市场线索新建
    @Prop() nameAngId: boolean; // 绑定的值是对象还是id

    allPage = 0
    page = 1
    limit = 20
    name = ''
    userList = []
    // 新增
    userId: string | object = null
    userName: string | object = null
    checked = false // 是否选中
    ids = []
    allCheck = false
    isIndeterminate = false

    changeUsers(e) {
        if (this.nameAngId) {
            this.$emit('changeUsers', {array: e})
        } else {
            const arr = []
            if (this.multiple) { // 多选
                e.forEach(item => {
                    this.userList.forEach(items => {
                        if (items.id === item) {
                            arr.push({
                                id: items.id,
                                realName: items.realName,
                                departmentName: items.departmentName,
                            })
                        }
                    })
                })
                this.$emit('changeUsers', {id: e, array: arr})
            } else { // 单选
                const UsersItem = (this.userList as any).filter(item => item.id === e)[0]
                this.$emit('changeUsers', (UsersItem || {id: e}))
            }
        }
    }



    loadmore() {
        this.page++
        this.getUserList();
    }


    // 计算属性 （同时监听两个值的变化）
    get userIdAndUserName() {
        const {usersId, usersName} = this
        return {
            usersId,
            usersName
        }
    }

    /*
    *
    * new
    * */

    async getUserList() {
        const data: any = await getUserList(delNullProperty({page: this.page, name: this.name}))
        this.userList = [...this.userList, ...data.userList]
        let result = []
        const obj = {}

        for (let i = 0; i < this.userList.length; i++) {
            if (!obj[this.userList[i].id]) {
                result.push(this.userList[i]);
                obj[this.userList[i].id] = true;
            }
        }

        this.userList = result
    }


    async handleUser() {
        if ((this.userList.length == 0 || !this.name) && !this.userName) {
            this.name = null
            this.page = 1
            const result: any = await getUserList(delNullProperty({page: this.page, name: this.name}))
            this.userList = result.userList
        }
        if (this.userName) {
            this.userList = []
            this.page = 1
            this.getUserList()
        }
    }

    async remoteMethod(query: any) {
        this.name = query
        this.page = 1
        if (query !== '') {
            const result: any = await getUserList(delNullProperty({page: this.page, name: query}))
            this.userList = result.userList
        } else {
            this.userList = []
            this.getUserList();
        }
    }

    clearUser() {
        this.userId = null
        this.userName = null
        this.name = null
        this.page = 1
        this.$emit('users-id',null)
        this.$emit('users-name',null)
        this.userList = []
        this.getUserList()
    }

    /*
    * old*/


    @Watch('userIdAndUserName', {deep: true, immediate: true})
    handleWatchUserId(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            this.userId = newVal.usersId // 编辑详情回显
            this.userName = newVal.usersName ? newVal.usersName : '' // 编辑详情回显
            if (!this.userId || (this.userId as any).length === 0) {
                this.userName = ''
                return
            }
            // 如果是编辑则获取当前id对应的信息

            if (typeof (this.userName) == 'string') {
                // -- 单选
                getUserList(delNullProperty({name: this.userName})).then(
                    (data: any) => {
                        this.userList = data.userList
                    }
                )
            } else if (typeof (this.userName) == 'object') {
                // --多选
                (this.userName as any[]).forEach(item => {
                    getUserList(delNullProperty({name: item.realName})).then(
                        (data: any) => {
                            this.userList = [...this.userList, ...data.userList]
                        }
                    )
                })
            }
        }
    }

}